module.exports = {
      id: "button-icon-usage",
      viewBox: "0 0 25.6 21.9",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#button-icon",
      toString: function () {
        return this.url;
      }
    }